export const posts = [
  {
    "slug": "late-summer-hours-2020-08-03",
    "title": "Set late-summer hours before the schedule flips, August 3, 2020",
    "seoTitle": "Late summer hours (contractor, August 3, 2020)",
    "description": "Late summer hours for a contractor on August 3, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-08-03",
    "cta": "This week, look at hours at the end of summer. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "August is when school nights and earlier closes sneak in. Write them before the first shortened day.",
          "This August 3, 2020 note is for a contractor. The check is late summer hours: hours at the end of summer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours at the end of summer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours at the end of summer. In August 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours at the end of summer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours at the end of summer before you add anything",
        "paragraphs": [
          "A mismatch on late summer hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare hours at the end of summer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-hours-2020-2020-08-10",
    "title": "Publish back-to-school hours the week they start, August 10, 2020",
    "seoTitle": "Back-to-school hours (salon, August 10, 2020)",
    "description": "Back-to-school hours for a salon on August 10, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-08-10",
    "cta": "This week, look at back-to-school hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "School schedules in 2020 change the rush hour. Write the hours you will keep once classes start, on the listing and the page.",
          "This August 10, 2020 note is for a salon. The check is back-to-school hours: back-to-school hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at back-to-school hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at back-to-school hours. In August 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Back-to-school hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix back-to-school hours before you add anything",
        "paragraphs": [
          "A mismatch on back-to-school hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare back-to-school hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set late-summer hours before the schedule flips, August 3, 2020",
        "href": "/blog/late-summer-hours-2020-08-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "august-pace-2020-08-17",
    "title": "Say whether August is a rush or a slowdown, August 17, 2020",
    "seoTitle": "August availability (clinic, August 17, 2020)",
    "description": "August availability for a clinic on August 17, 2020. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2020-08-17",
    "cta": "This week, look at how busy August actually is. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Some shops slam full and some go quiet. The page should match the calls you are getting, not last August's memory.",
          "This August 17, 2020 note is for a clinic. The check is August availability: how busy August actually is, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how busy August actually is",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how busy August actually is. In August 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How busy August actually is on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how busy August actually is before you add anything",
        "paragraphs": [
          "A mismatch on August availability is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare how busy August actually is. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "school-night-hours-2020-08-24",
    "title": "Publish school-night hours, August 24, 2020",
    "seoTitle": "School-night hours (restaurant, August 24, 2020)",
    "description": "School-night hours for a restaurant on August 24, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-08-24",
    "cta": "This week, look at hours once school is back. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If evenings change when classes start, change the listing that week. Parents book from the hours they see at dinner.",
          "This August 24, 2020 note is for a restaurant. The check is school-night hours: hours once school is back, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at hours once school is back",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at hours once school is back. In August 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Hours once school is back on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix hours once school is back before you add anything",
        "paragraphs": [
          "A mismatch on school-night hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare hours once school is back. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish back-to-school hours the week they start, August 10, 2020",
        "href": "/blog/school-hours-2020-2020-08-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "last-summer-offer-2020-08-31",
    "title": "End the summer offer on the day you chose, August 31, 2020",
    "seoTitle": "End date for a summer offer (law office, August 31, 2020)",
    "description": "End date for a summer offer, law office, August 31, 2020. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2020-08-31",
    "cta": "This week, look at the last day of the summer offer. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put the end date in the sentence. When it hits, take the sentence down.",
          "This August 31, 2020 note is for a law office. The check is end date for a summer offer: the last day of the summer offer, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the last day of the summer offer",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the last day of the summer offer. In August 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The last day of the summer offer on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the last day of the summer offer before you add anything",
        "paragraphs": [
          "A mismatch on end date for a summer offer is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the last day of the summer offer. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say whether August is a rush or a slowdown, August 17, 2020",
        "href": "/blog/august-pace-2020-08-17"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "labor-hours-2020-2020-09-07",
    "title": "Mark Labor Day closed if the door will be locked, September 7, 2020",
    "seoTitle": "Labor Day hours (retail shop, September 7, 2020)",
    "description": "Labor Day hours for a retail shop on September 7, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-09-07",
    "cta": "This week, look at Labor Day hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Labor Day 2020 is a Monday. Add the special hour. A description that mentions the holiday is not a substitute.",
          "This September 7, 2020 note is for a retail shop. The check is Labor Day hours: Labor Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Labor Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Labor Day hours. In September 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Labor Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Labor Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Labor Day hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Labor Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish school-night hours, August 24, 2020",
        "href": "/blog/school-night-hours-2020-08-24"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "fall-hours-2020-09-14",
    "title": "Publish fall hours the week they start, September 14, 2020",
    "seoTitle": "Fall hours (contractor, September 14, 2020)",
    "description": "Fall hours for a contractor on September 14, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-09-14",
    "cta": "This week, look at the fall schedule. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Earlier evenings and a different close belong on the listing the first day they are true.",
          "This September 14, 2020 note is for a contractor. The check is fall hours: the fall schedule, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the fall schedule",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the fall schedule. In September 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The fall schedule on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the fall schedule before you add anything",
        "paragraphs": [
          "A mismatch on fall hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the fall schedule. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Labor Day closed if the door will be locked, September 7, 2020",
        "href": "/blog/labor-hours-2020-2020-09-07"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "new-season-menu-2020-09-21",
    "title": "Post the new-season menu as text, September 21, 2020",
    "seoTitle": "Fall service list (salon, September 21, 2020)",
    "description": "Fall service list for a salon on September 21, 2020. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2020-09-21",
    "cta": "This week, look at the new-season list. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Type it. A photo of a chalkboard is not a menu a phone can search or read aloud.",
          "This September 21, 2020 note is for a salon. The check is fall service list: the new-season list, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the new-season list",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the new-season list. In September 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The new-season list on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the new-season list before you add anything",
        "paragraphs": [
          "A mismatch on fall service list is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the new-season list. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "september-photos-2020-09-28",
    "title": "Add September photos of the current work, September 28, 2020",
    "seoTitle": "September photos (clinic, September 28, 2020)",
    "description": "September photos for a clinic on September 28, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-09-28",
    "cta": "This week, look at photos from this month. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Show the season you are in. A beach photo in a fall gallery is the wrong promise.",
          "This September 28, 2020 note is for a clinic. The check is September photos: photos from this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at photos from this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at photos from this month. In September 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Photos from this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix photos from this month before you add anything",
        "paragraphs": [
          "A mismatch on September photos is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare photos from this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish fall hours the week they start, September 14, 2020",
        "href": "/blog/fall-hours-2020-09-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "halloween-hours-2020-10-05",
    "title": "Publish Halloween hours for the door you will open, October 5, 2020",
    "seoTitle": "Halloween hours (restaurant, October 5, 2020)",
    "description": "Halloween hours for a restaurant on October 5, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-10-05",
    "cta": "This week, look at Halloween hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close early or stay late for the evening, write both the close and the door. A normal Thursday schedule will be wrong.",
          "This October 5, 2020 note is for a restaurant. The check is Halloween hours: Halloween hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Halloween hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Halloween hours. In October 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Halloween hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Halloween hours before you add anything",
        "paragraphs": [
          "A mismatch on Halloween hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Halloween hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add September photos of the current work, September 28, 2020",
        "href": "/blog/september-photos-2020-09-28"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "fall-menu-october-2020-10-12",
    "title": "Update the October menu or service list, October 12, 2020",
    "seoTitle": "October menu (law office, October 12, 2020)",
    "description": "October menu for a law office on October 12, 2020. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2020-10-12",
    "cta": "This week, look at the October list. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "What you can do this month, in text. Pull items you dropped when the season turned.",
          "This October 12, 2020 note is for a law office. The check is October menu: the October list, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the October list",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the October list. In October 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The October list on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the October list before you add anything",
        "paragraphs": [
          "A mismatch on October menu is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the October list. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Post the new-season menu as text, September 21, 2020",
        "href": "/blog/new-season-menu-2020-09-21"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "october-photos-2020-10-19",
    "title": "Use an October photo of the real entrance, October 19, 2020",
    "seoTitle": "October entrance photo (retail shop, October 19, 2020)",
    "description": "October entrance photo for a retail shop on October 19, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-10-19",
    "cta": "This week, look at the entrance this month. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Decorations are fine if they are really there. The door and the hours in the frame matter more.",
          "This October 19, 2020 note is for a retail shop. The check is October entrance photo: the entrance this month, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the entrance this month",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the entrance this month. In October 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The entrance this month on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the entrance this month before you add anything",
        "paragraphs": [
          "A mismatch on October entrance photo is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the entrance this month. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish Halloween hours for the door you will open, October 5, 2020",
        "href": "/blog/halloween-hours-2020-10-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "halloween-hours-2020-2020-10-26",
    "title": "Publish Halloween day hours, October 26, 2020",
    "seoTitle": "Halloween hours (contractor, October 26, 2020)",
    "description": "Halloween hours for a contractor on October 26, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-10-26",
    "cta": "This week, look at Halloween day hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Halloween 2020 often means an earlier close or a later door. Write the day itself, not a vague seasonal note.",
          "This October 26, 2020 note is for a contractor. The check is Halloween hours: Halloween day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Halloween day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Halloween day hours. In October 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Halloween day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Halloween day hours before you add anything",
        "paragraphs": [
          "A mismatch on Halloween hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare Halloween day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Use an October photo of the real entrance, October 19, 2020",
        "href": "/blog/october-photos-2020-10-19"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "weekly-schedule-versus-thursday-2020-11-02",
    "title": "Do not leave a holiday Thursday on the weekly schedule, November 2, 2020",
    "seoTitle": "Holiday versus weekly hours (salon, November 2, 2020)",
    "description": "Holiday versus weekly hours for a salon on November 2, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-11-02",
    "cta": "This week, look at a holiday still showing as a normal day. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Special hours are for the day you close. The weekly schedule should stay the normal week so the following Thursday is right.",
          "This November 2, 2020 note is for a salon. The check is holiday versus weekly hours: a holiday still showing as a normal day, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a holiday still showing as a normal day",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a holiday still showing as a normal day. In November 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A holiday still showing as a normal day on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a holiday still showing as a normal day before you add anything",
        "paragraphs": [
          "A mismatch on holiday versus weekly hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare a holiday still showing as a normal day. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish Halloween day hours, October 26, 2020",
        "href": "/blog/halloween-hours-2020-2020-10-26"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "veterans-hours-2020-2020-11-09",
    "title": "Set Veterans Day hours if you close, November 9, 2020",
    "seoTitle": "Veterans Day hours (clinic, November 9, 2020)",
    "description": "Veterans Day hours for a clinic on November 9, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-11-09",
    "cta": "This week, look at Veterans Day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close or shorten Veterans Day 2020, write that day on the listing. The weekly schedule does not know the holiday.",
          "This November 9, 2020 note is for a clinic. The check is Veterans Day hours: Veterans Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Veterans Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Veterans Day hours. In November 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Veterans Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Veterans Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Veterans Day hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare Veterans Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Do not leave a holiday Thursday on the weekly schedule, November 2, 2020",
        "href": "/blog/weekly-schedule-versus-thursday-2020-11-02"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "early-retail-hours-2020-11-16",
    "title": "Publish earlier holiday shopping hours only if you keep them, November 16, 2020",
    "seoTitle": "Holiday shopping hours (restaurant, November 16, 2020)",
    "description": "Holiday shopping hours for a restaurant on November 16, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-11-16",
    "cta": "This week, look at extended hours you will really work. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you open early, write the early time. If you only talked about it, leave the listing alone.",
          "This November 16, 2020 note is for a restaurant. The check is holiday shopping hours: extended hours you will really work, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at extended hours you will really work",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at extended hours you will really work. In November 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Extended hours you will really work on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix extended hours you will really work before you add anything",
        "paragraphs": [
          "A mismatch on holiday shopping hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare extended hours you will really work. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Veterans Day hours if you close, November 9, 2020",
        "href": "/blog/veterans-hours-2020-2020-11-09"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "thanksgiving-hours-2020-2020-11-23",
    "title": "Write Thanksgiving week hours before Monday, November 23, 2020",
    "seoTitle": "Thanksgiving hours (law office, November 23, 2020)",
    "description": "Thanksgiving hours for a law office on November 23, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-11-23",
    "cta": "This week, look at Thanksgiving week hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write Thanksgiving 2020 hours on the listing before Monday. If Thursday is a normal weekly day, the map will show you open.",
          "This November 23, 2020 note is for a law office. The check is Thanksgiving hours: Thanksgiving week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Thanksgiving week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Thanksgiving week hours. In November 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Thanksgiving week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Thanksgiving week hours before you add anything",
        "paragraphs": [
          "A mismatch on Thanksgiving hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare Thanksgiving week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish earlier holiday shopping hours only if you keep them, November 16, 2020",
        "href": "/blog/early-retail-hours-2020-11-16"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "november-menu-2020-11-30",
    "title": "Publish the November menu or service list, November 30, 2020",
    "seoTitle": "November menu (retail shop, November 30, 2020)",
    "description": "November menu for a retail shop on November 30, 2020. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2020-11-30",
    "cta": "This week, look at the November list. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Holiday plates, packages, or services need a text list. A PDF from last November will be wrong and hard to open.",
          "This November 30, 2020 note is for a retail shop. The check is November menu: the November list, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the November list",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the November list. In November 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The November list on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the November list before you add anything",
        "paragraphs": [
          "A mismatch on November menu is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the November list. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the October menu or service list, October 12, 2020",
        "href": "/blog/fall-menu-october-2020-10-12"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "december-holiday-hours-2020-12-07",
    "title": "Write the hours between the holidays, December 7, 2020",
    "seoTitle": "Hours between holidays (contractor, December 7, 2020)",
    "description": "Hours between holidays for a contractor on December 7, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-12-07",
    "cta": "This week, look at the days between the holidays. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Christmas week and New Year's week are not the same schedule. Write each day you are closed.",
          "This December 7, 2020 note is for a contractor. The check is hours between holidays: the days between the holidays, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the days between the holidays",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the days between the holidays. In December 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The days between the holidays on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the days between the holidays before you add anything",
        "paragraphs": [
          "A mismatch on hours between holidays is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the days between the holidays. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Thanksgiving week hours before Monday, November 23, 2020",
        "href": "/blog/thanksgiving-hours-2020-2020-11-23"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "gift-cards-december-2020-12-14",
    "title": "Test the December gift card purchase, December 14, 2020",
    "seoTitle": "December gift cards (salon, December 14, 2020)",
    "description": "December gift cards for a salon on December 14, 2020. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2020-12-14",
    "cta": "This week, look at buying a gift card on a phone. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Go through the whole purchase on a phone. A card that errors at the last step is a lost sale and a bad afternoon.",
          "This December 14, 2020 note is for a salon. The check is December gift cards: buying a gift card on a phone, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at buying a gift card on a phone",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at buying a gift card on a phone. In December 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Buying a gift card on a phone on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix buying a gift card on a phone before you add anything",
        "paragraphs": [
          "A mismatch on December gift cards is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare buying a gift card on a phone. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "End the summer offer on the day you chose, August 31, 2020",
        "href": "/blog/last-summer-offer-2020-08-31"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "christmas-hours-2020-2020-12-21",
    "title": "Separate Christmas Eve, Christmas Day, and the days after, December 21, 2020",
    "seoTitle": "Christmas hours (clinic, December 21, 2020)",
    "description": "Christmas hours for a clinic on December 21, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-12-21",
    "cta": "This week, look at Christmas week hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write Christmas Eve, Christmas Day, and the day you reopen for 2020. One line that says \"closed for the holidays\" is not a schedule.",
          "This December 21, 2020 note is for a clinic. The check is Christmas hours: Christmas week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Christmas week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Christmas week hours. In December 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Christmas week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Christmas week hours before you add anything",
        "paragraphs": [
          "A mismatch on Christmas hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare Christmas week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write the hours between the holidays, December 7, 2020",
        "href": "/blog/december-holiday-hours-2020-12-07"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "new-year-hours-2021-2020-12-28",
    "title": "Set New Year hours before the week starts, December 28, 2020",
    "seoTitle": "New Year hours (restaurant, December 28, 2020)",
    "description": "New Year hours for a restaurant on December 28, 2020. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2020-12-28",
    "cta": "This week, look at New Year hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write the hours for the last days of 2020 and the first day of 2021. A normal weekly schedule will show you open on a day the door is locked.",
          "This December 28, 2020 note is for a restaurant. The check is New Year hours: New Year hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at New Year hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at New Year hours. In December 2020 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "New Year hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix New Year hours before you add anything",
        "paragraphs": [
          "A mismatch on New Year hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare New Year hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2020 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate Christmas Eve, Christmas Day, and the days after, December 21, 2020",
        "href": "/blog/christmas-hours-2020-2020-12-21"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  }
];
